import { _ } from "../../../polyglot/polyglot.js";
import AbstractRoadmapStep from "../../AbstractRoadmapStep.js";
import AccountGroupSetterLineWidget from "./AccountGroupSetterLineWidget/AccountGroupSetterLineWidget.js";
import SingleAccountSpecification from "../../../../models/accountSpecification/SingleAccountSpecification.js";

/**
 * This allows the user to choose VAT accounts.
 */
export default class VatStep extends AbstractRoadmapStep {
	getTitle() {
		return _("Existing VAT");
	}

	_getSubtitle() {
		return _(
			"One or more accounts in your existing bookkeeping may hold VAT and this needs to be paid, so let's set the accounts.",
		);
	}

	_doStart() {
		if (!this._getIncomingVatGroup())
			this._setIncomingVatGroup(
				new SingleAccountSpecification({
					number: this._context.configuration.getIncomingVat(),
				}),
			);

		if (!this._getOutgoingVatGroup())
			this._setOutgoingVatGroup(
				new SingleAccountSpecification({
					number: this._context.configuration.getOutgoingVat(),
				}),
			);

		if (!this._getSumVatGroup())
			this._setSumVatGroup(
				new SingleAccountSpecification({
					number: this._context.configuration.getVatSumAccount(),
				}),
			);
	}

	_getIncomingVatGroup() {
		return this._context.configuration.getIncomingVatGroup();
	}

	_setIncomingVatGroup(group) {
		this._context.configuration.setIncomingVatGroup(group);
	}

	_getOutgoingVatGroup() {
		return this._context.configuration.getOutgoingVatGroup();
	}

	_setOutgoingVatGroup(group) {
		this._context.configuration.setOutgoingVatGroup(group);
	}

	_getSumVatGroup() {
		return this._context.configuration.getSumVatGroup();
	}

	_setSumVatGroup(group) {
		this._context.configuration.setSumVatGroup(group);
	}

	_getStepContent() {
		const configuration = this._context.configuration;

		return (html) =>
			html.div(
				{ class: "existing-vat-accounts" },
				html.div(
					{ class: "actions" },
					new AccountGroupSetterLineWidget({
						title: _("Input VAT accounts"),
						titleCssClass: "action-label",
						helpText: _(
							"Include any accounts that you use in your bookkeeping software for VAT on supplier invoices.",
						),
						dataTestName: "incoming-vat-accounts",
						inputName: _("Intervals"),
						accessor: () => configuration.getIncomingVatGroup(),
						mutator: (values) =>
							configuration.setIncomingVatGroup(values),
					}),
				),
				html.div(
					{ class: "actions" },
					new AccountGroupSetterLineWidget({
						title: _("Output VAT accounts"),
						titleCssClass: "action-label",
						helpText: _(
							"Include any accounts that you use in your bookkeeping software for VAT on sales invoices.",
						),
						dataTestName: "outgoing-vat-accounts",
						inputName: _("Intervals"),
						accessor: () => configuration.getOutgoingVatGroup(),
						mutator: (values) =>
							configuration.setOutgoingVatGroup(values),
					}),
				),
				html.div(
					{ class: "actions" },
					new AccountGroupSetterLineWidget({
						title: _("Net VAT accounts"),
						titleCssClass: "action-label",
						helpText: _(
							"Include any accounts that holds VAT debt due to the Tax authority.",
						),
						dataTestName: "net-vat-accounts",
						inputName: _("Intervals"),
						accessor: () => configuration.getSumVatGroup(),
						mutator: (values) =>
							configuration.setSumVatGroup(values),
					}),
				),
			);
	}
}
